import imageUrlBuilder from '@sanity/image-url';
import { baseSanityConfig } from './baseConfig';

export const sanityImageBuilder = imageUrlBuilder(baseSanityConfig);
